import GenericFilter, { Item } from "@/components/Filters/GenericFilter";
import { IconCalendarEvent } from "@tabler/icons-react";

export default function MetaTimeFilter({
  selected,
  setSelected,
}: {
  selected: Set<any>;
  setSelected: (selectedOptions: Set<string>) => void;
}) {
  let data: Item[] = [
    { key: "2 Weeks", value: "2 Weeks" },
    { key: "Month", value: "Month" },
    { key: "All", value: "All" },
  ];

  return (
    <GenericFilter
      classNames="w-[130px] lg:w-[130px]"
      selected={selected}
      selectionMode="single"
      setSelected={setSelected}
      startContent={<IconCalendarEvent />}
      label="Time filter"
      data={data}
      disallowEmptySelection={true}
    />
  );
}
